import { render, staticRenderFns } from "./confirmSMS.popup-chunk.vue?vue&type=template&id=f0d295e0&scoped=true"
import script from "./confirmSMS.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmSMS.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./confirmSMS.popup-chunk.vue?vue&type=style&index=0&id=f0d295e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d295e0",
  null
  
)

export default component.exports